"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Confirm = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_toastify_1 = require("react-toastify");
require("./confirm.scss");
var Accept_1 = require("../../components/Icons/Accept");
var react_redux_1 = require("react-redux");
var axios_1 = __importDefault(require("../../utils/axios"));
var react_activity_1 = require("react-activity");
var react_i18next_1 = require("react-i18next");
var actions_1 = require("../../store/payment/actions");
var react_router_1 = require("react-router");
var react_router_dom_1 = require("react-router-dom");
var reducer_1 = require("../../store/restaurant/reducer");
var network_1 = require("../../network");
var actions_2 = require("../../store/cart/actions");
var Confirm = function () {
    var _a, _b;
    var t = (0, react_i18next_1.useTranslation)().t;
    var history = (0, react_router_dom_1.useHistory)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var _c = (0, react_1.useState)(''), email = _c[0], setEmail = _c[1];
    var _d = (0, react_1.useState)(false), loading = _d[0], setLoading = _d[1];
    var _e = (0, react_1.useState)(false), sendedReceipt = _e[0], setSendedReceipt = _e[1];
    var restaurantId = (0, react_router_1.useParams)().restaurant;
    var searchParams = new URLSearchParams(location.search);
    var key = searchParams.get('key') || '';
    var type = searchParams.get('type') || '';
    var _f = (0, network_1.useGetRestaurant)({ id: restaurantId }).data, restaurant = _f === void 0 ? {} : _f;
    var _g = (0, react_redux_1.useSelector)(function (state) { return ({
        pickupTime: state.cart.pickupTime,
        table: state.cart.table,
        order_id: state.payment.order_id,
        status: state.payment.status,
        confirmed: state.payment.confirmed,
    }); }), order_id = _g.order_id, status = _g.status, confirmed = _g.confirmed, pickupTime = _g.pickupTime, table = _g.table;
    var tableNumber = ((_a = restaurant.tables) === null || _a === void 0 ? void 0 : _a.length) ? ((_b = restaurant.tables.find(function (item) { return String(item.id) === table; })) === null || _b === void 0 ? void 0 : _b.number) || '' : table;
    var sendReceipt = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setLoading(true);
                    if (!email) {
                        react_toastify_1.toast.error('Please enter your email');
                        setSendedReceipt(false);
                        setLoading(false);
                        return [2];
                    }
                    return [4, axios_1.default.post("/api/receipt", {
                            key: key,
                            email: email,
                            order_id: order_id,
                        })];
                case 1:
                    response = _c.sent();
                    if (((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.message) && ((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.message) == 'ok') {
                        react_toastify_1.toast.success('Your reciept has been sent');
                        setSendedReceipt(true);
                        setLoading(false);
                        return [2];
                    }
                    else {
                        react_toastify_1.toast.error('no order');
                        setSendedReceipt(false);
                        setLoading(false);
                        return [2];
                    }
                    setLoading(false);
                    return [2];
            }
        });
    }); };
    var skip = function () {
        var prevParams = Object.fromEntries(searchParams);
        if (prevParams.key) {
            delete prevParams.key;
        }
        var URLParams = new URLSearchParams(prevParams);
        history.push({ pathname: "/store/".concat(restaurantId), search: URLParams.toString() });
    };
    var toMenu = function () {
        var prevParams = Object.fromEntries(searchParams);
        if (prevParams.key) {
            delete prevParams.key;
        }
        var URLParams = new URLSearchParams(prevParams);
        history.push({ pathname: "/store/".concat(restaurantId), search: URLParams.toString() });
    };
    var Header = function () {
        if (confirmed === null && !sendedReceipt) {
            return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [t('Please waiting for confirm payment'), (0, jsx_runtime_1.jsx)("div", __assign({ className: "confirm-spinner" }, { children: (0, jsx_runtime_1.jsx)(react_activity_1.Spinner, {}) }))] }));
        }
        if (confirmed && !sendedReceipt) {
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: t('Payment Successful') });
        }
        else if (!sendedReceipt) {
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: t('Payment Canceled') });
        }
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    };
    var Content = function () {
        if (confirmed) {
            return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "order-information" }, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ className: "order-information-id" }, { children: order_id && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [t('Your Order ID'), ": ", (0, jsx_runtime_1.jsx)("strong", { children: order_id })] })) })), type === reducer_1.RestaurantDeliveryType.Pickup && pickupTime && ((0, jsx_runtime_1.jsxs)("span", __assign({ className: "order-information-type" }, { children: [t('Pick-up Time'), " # ", pickupTime] }))), type === reducer_1.RestaurantDeliveryType.Dinein && tableNumber && ((0, jsx_runtime_1.jsxs)("span", __assign({ className: "order-information-type" }, { children: [t('Table'), " # ", tableNumber] })))] })), sendedReceipt ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "card-title", style: { marginBottom: 20 } }, { children: 'Your receipt has been sent' })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "confirm-buttons" }, { children: (0, jsx_runtime_1.jsx)("button", __assign({ className: "custom-button confirm-button", onClick: skip }, { children: t('Skip') })) }))] })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "card-accept-icon" }, { children: (0, jsx_runtime_1.jsx)(Accept_1.Accept, {}) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "", style: { width: '100%' } }, { children: (0, jsx_runtime_1.jsx)("input", { className: "confirm-input", type: "text", name: "email", style: { fontSize: '14px' }, value: email, onChange: function (e) { return setEmail(e.target.value); }, placeholder: t('Enter your email to recieve a digital receipt') }, "email") })), (0, jsx_runtime_1.jsx)("div", { children: loading ? ((0, jsx_runtime_1.jsx)("div", __assign({ className: "confirm-spinner" }, { children: (0, jsx_runtime_1.jsx)(react_activity_1.Spinner, {}) }))) : ((0, jsx_runtime_1.jsx)("div", __assign({ className: "confirm-buttons" }, { children: (0, jsx_runtime_1.jsx)("button", __assign({ className: "custom-button confirm-button", onClick: sendReceipt }, { children: t('Send') })) }))) })] }))] }));
        }
        return ((0, jsx_runtime_1.jsx)("button", __assign({ className: "custom-button confirm-button", onClick: toMenu }, { children: t('back to menu') })));
    };
    (0, react_1.useEffect)(function () {
        if (key) {
            dispatch((0, actions_1.checkPayment)(key));
        }
    }, [key]);
    (0, react_1.useEffect)(function () {
        if (status === 'accepted' && confirmed) {
            dispatch((0, actions_2.cartClear)());
            dispatch((0, actions_1.clearPaymentIntent)());
        }
    }, [status]);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "confirm-container" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "card" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "card-title" }, { children: (0, jsx_runtime_1.jsx)(Header, {}) })), Content()] })) })) }));
};
exports.Confirm = Confirm;
